import { render } from "./SelectedBusinessUnit.vue?vue&type=template&id=771d39e6"
import script from "./SelectedBusinessUnit.vue?vue&type=script&lang=js"
export * from "./SelectedBusinessUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__